import { css } from '@emotion/react';
import { formatDate } from '@frontend/date';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { ERROR_MESSAGES, VerificationError } from '../utils/constants';
import { InsuranceDetails } from '../utils/types';
import { DetailText } from './detail-text';

interface Props {
  insuranceDetails: InsuranceDetails;
  isIntegratedOffice?: boolean;
}

export const InsuranceDetailList = ({ insuranceDetails, isIntegratedOffice = false }: Props) => {
  const { t } = useTranslation('insuranceDetails');

  const isInActiveInsurance = insuranceDetails?.coverageStatus?.toLowerCase() === 'inactive';

  const sanitizePayerDetails = (payerDetails: string): string => {
    return payerDetails === VerificationError.WEAVE_PAYER_NOT_SUPPORTED
      ? ERROR_MESSAGES.payer_not_supported
      : payerDetails;
  };
  return (
    <dl css={listStyle}>
      <div>
        <Text as='dt'>{t('Payer ID')}</Text>
        <DetailText
          value={sanitizePayerDetails(insuranceDetails.payerId || insuranceDetails?.pmsPayerId || '')}
          required
        />
      </div>
      <div>
        <Text as='dt'>{t('Payer name')}</Text>
        <DetailText value={insuranceDetails.payerName} required />
      </div>
      {isIntegratedOffice && (
        <div>
          <Text as='dt'>{t('PMS Payer ID')}</Text>
          <DetailText value={insuranceDetails?.pmsPayerId || ''} />
        </div>
      )}
      <div>
        <Text as='dt'>{t('Group Number')}</Text>
        <DetailText value={insuranceDetails.groupNumber} />
      </div>
      <div>
        <Text as='dt'>{t('Group Name')}</Text>
        <DetailText value={insuranceDetails.groupName} />
      </div>
      <div>
        <Text as='dt'>{t('Member ID')}</Text>
        <DetailText value={insuranceDetails.memberId} required />
      </div>
      {!isInActiveInsurance ? (
        <div>
          <Text as='dt'>{t('Effective Date')}</Text>
          <DetailText
            value={insuranceDetails.effectiveDate ? formatDate(insuranceDetails.effectiveDate, 'MMMM D, YYYY') : '-'}
          />
        </div>
      ) : (
        <div>
          <Text as='dt'>{t('End Date')}</Text>
          <DetailText value={insuranceDetails?.endDate ? formatDate(insuranceDetails?.endDate, 'MMMM D, YYYY') : '-'} />
        </div>
      )}
    </dl>
  );
};

const listStyle = css`
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${theme.spacing(2)};
  grid-auto-flow: dense;
  > div {
    display: flex;
    flex-direction: column;

    dt {
      margin-right: ${theme.spacing(4)};
      font-size: ${theme.fontSize(12)};
      margin-bottom: ${theme.spacing(0.5)};
      color: ${theme.font.colors.subdued};
    }
  }
`;
